export const useCanOverrideFeatures = () => {
  return (
    localStorage.getItem('IS_IMPERSONATING') === 'true' ||
    window.location.hostname.endsWith('localhost') ||
    window.location.hostname.endsWith('.wrkpth.dev')
  );
};
